<template lang="pug">
.wechat-mp-card-container(:class='{ nogray: !gray }')
  template(v-show='!loading')
    .placeholder.place-1(v-show='gray', :style='{ height: height[0] }')
    template(v-if='gray')
      template(v-if='card || success')
        .card-wrapper
          img.card-bg(:src='pics.bg.card')
          template(v-if='success')
            .card-success
              .card-success-title 购买成功
              .card-success-subtitle {{ card ? card.title || title : title }}
              img.card-success-icon(:src='pics.success')
          template(v-else)
            .card
              .card-top
                img.card-icon(:src='cardIcon')
                .card-content
                  .card-title {{ card.title }}
                  .card-tags {{ card.tags.join(" | ") }}
              .card-price
                span.card-price-text 专享价：
                span.card-current-price {{ card.currentPrice }}
                span.card-price-text 元&nbsp;&nbsp;
                span.card-original-price.del {{ card.originalPrice }} 元
              .card-button.flex-mid(@click='buy') 立即购买
      template(v-else)
        img.no-card-bg(:src='pics.bg.common')
      .placeholder.place-2(:style='{ height: height[1] }')
    template(v-else)
      img.no-gray-card(:src='pics.bg.nogray')
    .buttons
      .go-use.button-item.flex-mid(@click='goUse') 继续用车
      .download.button-item.flex-mid(@click='download') 下载哈啰APP用车
</template>

<script>
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import Toast from '@/components/toast';
import { getTWCards } from '@/api/card';
import { CardService } from '@/service/card';
import { configWechatSDK } from '@/utils/wechat';
import { env } from '@hb/NBridge/lib/h5';
import {
  getTokenAndLocation, getTWCardPlatform, tryCatch, isPreRender,
} from '../../utils';
import { getVersion } from '../../utils/systemCode';
import { formatCardTags } from '../../utils/card';
import { ParamsUtil } from '../../utils/params';

// const MOCK_CARD = {
//   days: 30,
//   title: '30天·连续包月·APP专享卡',
//   tags: [
//     '限上海市',
//     '限哈啰APP',
//     '很多字很多字很多字很多字很多字很多字很多字很多字很多字很多字很多字很多字很多字',
//   ],
//   currentPrice: '9.9',
//   originalPrice: '25',
//   item: {},
// };
const { clientHeight, clientWidth } = document.documentElement;

const ratioDiff = Math.max(clientHeight / clientWidth - 667 / 375, 0);
const place1PerRatioA = 0.3 / (812 / 375 - 667 / 375);
const place2PerRatioA = 0.1 / (812 / 375 - 667 / 375);

const place1PerRatioB = 0.3 / (812 / 375 - 667 / 375);
const place2PerRatioB = 0.1 / (812 / 375 - 667 / 375);

export default {
  data() {
    return {
      loading: true,
      success: false,
      hasCard: true, // 有卡
      gray: false, // 灰度，新旧
      title: '',
      card: null,
      params: {
        actionOrigin: 'PlatformSellingCard',
        channelCode: 102102,
      },
      pics: {
        card: {
          60: 'https://m.hellobike.com/resource/helloyun/07177/qCeSvw8-J7.png',
          30: 'https://m.hellobike.com/resource/helloyun/07177/yxK7gK1_nb.png',
          15: 'https://m.hellobike.com/resource/helloyun/07177/z47HatiBCr.png',
          7: 'https://m.hellobike.com/resource/helloyun/07177/Fi3vA-RWEE.png',
          fallback:
            'https://m.hellobike.com/resource/helloyun/07177/ksaAtFNQqE.png',
        },
        bg: {
          card:
            'https://m.hellobike.com/resource/helloyun/07177/nT0LWIPqUc.png',
          common:
            'https://m.hellobike.com/resource/helloyun/07177/KHzdCv4KJD.png',
          nogray:
            'https://m.hellobike.com/resource/helloyun/07177/4ttD6_bike-mp-main.png',
        },
        success:
          'https://m.hellobike.com/resource/helloyun/07177/IxNuRpIhrT.png',
      },
    };
  },
  computed: {
    cardIcon() {
      return tryCatch(
        () => this.pics.card[this.card.days] || this.pics.card.fallback,
        this.pics.card.fallback,
      );
    },
    height() {
      if (this.card) {
        return [
          `${place1PerRatioA * ratioDiff}rem`,
          `${0.5 + place2PerRatioA * ratioDiff}rem`,
        ];
      }
      return [
        `${0.81 + place1PerRatioB * ratioDiff}rem`,
        `${1.31 + place2PerRatioB * ratioDiff}rem`,
      ];
    },
  },
  created() {
    // if (isPreRender()) {
    //   document.dispatchEvent(new Event('render-event'));
    //   // eslint-disable-next-line no-useless-return
    //   return;
    // }

    const {
      gray, hasCard, success, title,
    } = this.$route.query;
    this.gray = Boolean(gray);
    this.hasCard = Boolean(hasCard);
    this.success = Boolean(success);
    if (title) {
      this.title = title;
    }
    if (!success || !title) {
      if (this.gray && !this.hasCard) {
        this.getData();
      } else {
        this.loading = false;
      }
    } else {
      this.card = {};
      this.loading = false;
    }
    this.config();
  },
  methods: {
    async config() {
      if (env.isWechatMini) {
        configWechatSDK();
      }
    },
    goUse() {
      if (window.wx) {
        if (this.gray) {
          UBT.clickButton({
            pageId: 'newebike_H5wechat',
            buttonName: 'ebikeh5_goon',
            categoryId: 'platform',
            businessInfo: {},
          });
        } else {
          UBT.clickButton({
            pageId: 'ebike_wechatH5',
            buttonName: 'ebikeH5_go',
            categoryId: 'platform',
            businessInfo: {},
          });
        }
        window.wx.miniProgram.navigateTo({
          url: '/pages/AppHelloOhoWeChat/src/pages/index/index',
        });
      }
    },
    download() {
      if (this.gray) {
        UBT.clickButton({
          pageId: 'newebike_H5wechat',
          buttonName: 'nebikeH5_download',
          categoryId: 'platform',
          businessInfo: {},
        });
      } else {
        UBT.clickButton({
          pageId: 'ebike_wechatH5',
          buttonName: 'ebikeH5_download',
          categoryId: 'platform',
          businessInfo: {},
        });
      }
      setTimeout(() => {
        window.location.href = 'https://m.hellobike.com/mf/spa/u_yskixp/latest/MA2110262519624662885859328.html?activityCode=MA2110262519624662885859328';
      });
    },
    async buy() {
      if (!this.card) {
        return;
      }
      UBT.clickButton({
        pageId: 'newebike_H5wechat',
        buttonName: 'ebikeh5_appcard',
        categoryId: 'platform',
        businessInfo: {
          card_name: this.card.title,
        },
      });
      CardService.buy(
        this.card.item,
        Object.assign(this.params, {
          returnUrl: ParamsUtil.addParams(window.location.href, {
            gray: this.gray,
            success: 1,
            title: this.card.title,
          }),
        }),
      ).catch((e) => {
        if (e) {
          Toast.showError(e);
        }
      });
    },
    async getData() {
      if (!this.gray || this.hasCard) {
        return;
      }
      const { token, cityCode, adCode } = await getTokenAndLocation();

      const group = await getTWCards({
        token,
        adCode,
        cityCode,
        businessId: 0, // 单车
        channelCodes: [102102],
        platform: getTWCardPlatform(),
        version: await getVersion(),
      })
        .then((v) => tryCatch(() => v.data.packageGroups[0]), null)
        .catch(() => null);
      if (!group) {
        return;
      }
      const { packages, ...others } = group;
      const card = tryCatch(() => packages[0], null);
      Object.assign(this.params, others);
      this.loading = false;
      if (!card) {
        return;
      }
      const {
        cardBatchInfo,
        originPrice,
        actualPrice,
        purchasePrice,
        showName,
      } = card;
      UBT.moduleExpose({
        pageId: 'newebike_H5wechat',
        categoryId: 'platform',
        moduleId: 'ebikeh5_appcard',
        contentId: 'ebikeh5_appcard',
        exposureTimes: 1,
        businessInfo: {
          card_name: showName,
        },
      });
      this.card = {
        title: showName,
        days: tryCatch(() => cardBatchInfo.effectDay, null),
        currentPrice: tryCatch(() => actualPrice.finalPrice, purchasePrice),
        originalPrice: originPrice,
        tags: formatCardTags(card).map((v) => v.wordsValue),
        item: card,
      };
    },
  },
};
</script>

<style lang="less">
.wechat-mp-card-container {
  height: 100vh;
  background: #fff;

  .placeholder {
    width: 100%;
  }

  .no-gray-card {
    width: 100%;
  }

  .no-card-bg {
    height: 2.02rem;
  }

  .buttons {
    display: flex;
    flex-direction: column;
    align-items: center;

    .button-item {
      width: 3.23rem;
      height: 0.48rem;
      border-radius: 0.08rem;
      font-size: 0.17rem;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 500;

      &:not(:last-of-type) {
        margin-bottom: 0.2rem;
      }
    }

    .go-use {
      background: #08f;
      color: #fff;
    }

    .download {
      background: #f0f3f5;
      color: #08f;
    }
  }

  &.nogray {
    .buttons {
      .button-item {
        width: 3rem;
        height: 0.48rem;
        border-radius: 2.96rem;

        &.download {
          background: #f0f3f5;
          color: #5a6066;
        }
      }
    }
  }

  .card-wrapper {
    position: relative;

    .card-bg {
      width: 100%;
    }

    .card-success {
      height: 1.88rem;
      width: 3.23rem;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);

      .card-success-title {
        position: absolute;
        left: 0.2rem;
        top: 0.26rem;
        font-size: 0.24rem;
        font-family: PingFangSC-Semibold, PingFang SC, sans-serif;
        font-weight: 600;
        color: #0081f1;
        line-height: 0.33rem;
      }

      .card-success-subtitle {
        position: absolute;
        left: 0.2rem;
        top: 0.61rem;
        font-size: 0.14rem;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-weight: 500;
        color: #0081f1;
        line-height: 0.2rem;
      }

      .card-success-icon {
        position: absolute;
        right: 0.16rem;
        top: 0.22rem;
        width: 0.62rem;
        height: 0.66rem;
      }
    }

    .card {
      height: 1.88rem;
      width: 3.23rem;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);

      .card-price {
        position: absolute;
        left: 0.06rem;
        bottom: 0.22rem;

        .card-price-text {
          font-size: 0.14rem;
          font-family: PingFangSC-Semibold, PingFang SC, sans-serif;
          font-weight: 600;
          color: #0081f1;
        }

        .card-current-price {
          font-size: 0.26rem;
          font-family: DINAlternate-Bold, DINAlternate, sans-serif;
          font-weight: bold;
          color: #0081f1;
        }

        .card-original-price {
          font-size: 0.14rem;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          color: #08f;
        }
      }

      .card-button {
        position: absolute;
        display: inline-flex;
        right: 0.06rem;
        bottom: 0.22rem;
        width: 0.96rem;
        height: 0.38rem;
        background: #08f;
        border-radius: 0.08rem;
        font-size: 0.16rem;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-weight: 500;
        color: #fff;
      }

      .card-top {
        display: flex;
        padding: 0.2rem 0.16rem;

        .card-icon {
          width: 0.56rem;
          height: 0.72rem;
          border-radius: 0.06rem;
        }

        .card-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          padding-left: 0.12rem;

          .card-title {
            font-size: 0.16rem;
            font-weight: 600;
            color: #242729;
            line-height: 0.22rem;
            margin-bottom: 0.04rem;
          }

          .card-tags {
            font-size: 0.12rem;
            color: #879099;
            line-height: 0.17rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
      }
    }
  }
}
</style>
